import React from 'react';
import { func, instanceOf } from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';

import IconMoreHorz from '../../shared/icons/IconMoreHorz';

const ContextMenu = ({ row, onClick, removeHover, setHover }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    setHover(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    removeHover();
  };

  const _handleOptionClick = (event, name) => {
    handleClose();
    onClick(row, name);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="de--label--context-menu">
      <IconButton
        aria-describedby={id}
        className="de--label-table-body-row-rightCol__actions--button"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <IconMoreHorz />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className="de--label--context-popover"
      >
        <div className="de--label--context-root">
          <button
            type="button"
            onClick={e => _handleOptionClick(e, 'editLabel')}
            className="de--label--context-item"
            data-test="editlabel"
          >
            <span>Edit Label</span>
          </button>
          {row.sl !== row.tl && <button
            type="button"
            onClick={e => _handleOptionClick(e, 'restoreLabel')}
            className="de--label--context-item"
            data-test="restorelabel"
          >
            <span>Restore Label</span>
          </button>}
          {row.tl && <button
            type="button"
            onClick={e => _handleOptionClick(e, 'clearLabel')}
            className="de--label--context-item"
            data-test="clearlabel"
          >
            <span>Clear Label</span>
          </button>}
        </div>
      </Popover>
    </div>
  );
};

ContextMenu.propTypes = {
  row: instanceOf(Object),
  onClick: func,
  removeHover: func,
  setHover: func,
};

export default ContextMenu;
